// extracted by mini-css-extract-plugin
export default {"wrapper":"css_wrapper__GBo2h","closeButton":"css_closeButton__0bVxI"};